import { render } from "./CertificateFilters.vue?vue&type=template&id=678e84c0&scoped=true"
import script from "./CertificateFilters.vue?vue&type=script&lang=js"
export * from "./CertificateFilters.vue?vue&type=script&lang=js"

import "./CertificateFilters.vue?vue&type=style&index=0&id=678e84c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678e84c0"]])

export default __exports__